<template>
    <div id="contact-us" class="contact-us">
        <b-alert :show="successMessage" variant="success" dismissible @dismissed="successMessage = false">
            Thank you! Your message has been sent successfully.
        </b-alert>
        <b-alert :show="errorMessage" variant="danger" dismissible @dismissed="errorMessage = false">
            Sorry, we could not send your message. Please try again later.
        </b-alert>
        <b-form v-if="!successMessage" @submit.prevent="onSubmit" class="p-2">
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <b-form-input type="text" id="first_name" name="first_name" placeholder="First Name"
                                      v-model="form.first_name" required>
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group>
                        <b-form-input type="text" id="last_name" name="last_name" placeholder="Last Name"
                                      v-model="form.last_name" required>
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <b-form-input type="email" id="email" name="email" placeholder="Email"
                                      v-model="form.email" required>
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group>
                        <b-form-input type="text" id="phone" name="phone" placeholder="Phone Number"
                                      v-model="form.phone">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <b-form-input type="text" id="current_agent" name="current_agent"
                                      placeholder="Current Agent (if applicable)"
                                      v-model="form.current_agent">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <b-form-textarea
                            id="message"
                            v-model="form.message_text"
                            :placeholder="this.placeholder_text"
                            rows="10"
                            max-rows="8"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button type="submit" :disabled="isSubmitting" variant="primary">Submit</b-button>
        </b-form>
    </div>
</template>

<script>

export default {
    name: 'contact-us',
    props: {
        placeholder_text: {
            type: String
        },
        agent_email: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            env: process.env.MIX_APP_ENV,
            sitekey: process.env.MIX_RECAPTCHA_SITE_KEY,
            isSubmitting: false,
            successMessage: false,
            errorMessage: false,
            form: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                current_agent: null,
                agent_email: this.agent_email,
                message_text: null,
            }
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
            this.isSubmitting = true;
            let data = {
                form: this.form,
            };
            this.sendForm(data);
        },
        sendForm(data) {
            let _self = this;
            axios.post('/api/contact-mailer', data.form)
                .then(function (response) {
                    _self.isSubmitting = false;
                    _self.errorMessage = false;
                    _self.successMessage = true;
                    _self.form = {
                        first_name: null,
                        last_name: null,
                        email: null,
                        phone: null,
                        current_agent: null,
                        agent_email: _self.agent_email,
                        message_text: null,
                    };
                    _self.$eventHub.$emit('mailer::sent');
                }).catch(() => {
                _self.isSubmitting = false;
                _self.errorMessage = true;
            })
        }
    },
}
</script>

